import PostIndex from "../postindex/PostIndex";


export default function Blog() {


  return (
    <>
      <PostIndex
        pagePath="blog"
      />
    </>
  )
}